import { render, staticRenderFns } from "./orderProductInfo.vue?vue&type=template&id=492198da"
import script from "./orderProductInfo.vue?vue&type=script&lang=js"
export * from "./orderProductInfo.vue?vue&type=script&lang=js"
import style0 from "./orderProductInfo.vue?vue&type=style&index=0&id=492198da&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports